import FooterOne from '../Footer/FooterOne';
import Header from '../Header/HeaderOne';
import { pageTitle } from '../PageTitle';
import React, { useEffect, useState } from 'react';
import Preloader from '../Preloader/Preloader';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../services/firebase/config';
import useOrgRatingStore from '../../store/orgRatingStore';
import ReactPaginate from 'react-paginate';
import '../../assets/sass/Pagination.css'


const OrgRatingPage = () => {
    pageTitle("ORG RATING")
    const { orgRating, setOrgRating, isLoading, setLoading } = useOrgRatingStore();
    const [firstValues, setFirstValues] = useState({ tour: 0, prize: 0, comm: 0 });


    const fetchData = async () => {
        setLoading(true);
        try {
            const querySnapshot = await getDocs(collection(db, 'orgRating'));
            const data = querySnapshot.docs.map(doc => doc.data());
            setOrgRating(data);
            localStorage.setItem('orgLastFetchTime', Date.now().toString()); 
            localStorage.setItem('orgRating', JSON.stringify(data));
        } catch (error) {
            console.error('Ошибка при загрузке данных:', error);
        }
    };

    const shouldFetchData = () => {
        const lastFetchTime = localStorage.getItem('orgLastFetchTime');
        const currentTime = Date.now();
        const twelveHoursInMillis = 12 * 60 * 60 * 1000; 

        return !lastFetchTime || (currentTime - parseInt(lastFetchTime)) > twelveHoursInMillis;
    };
    

    useEffect(() => {

        const storedOrgRating = localStorage.getItem('orgRating');
        if (shouldFetchData()) {
            fetchData().then(() => {
                JSON.parse(storedOrgRating).sort((x, y) => (+y.prize + +y.tour + +y.comm) - (+x.prize + +x.tour + +x.comm))
                const maxTour = Math.max(...JSON.parse(storedOrgRating).map(org => org.tour), 0);
                const maxPrize = Math.max(...JSON.parse(storedOrgRating).map(org => org.prize), 0);
                const maxComm = Math.max(...JSON.parse(storedOrgRating).map(org => org.comm), 0);
                setFirstValues({ tour: maxTour, prize: maxPrize, comm: maxComm });
            })
        } else if (storedOrgRating) {
            setOrgRating(JSON.parse(storedOrgRating));
            JSON.parse(storedOrgRating).sort((x, y) => (+y.prize + +y.tour + +y.comm) - (+x.prize + +x.tour + +x.comm))
            const maxTour = Math.max(...JSON.parse(storedOrgRating).map(org => org.tour), 0);
            const maxPrize = Math.max(...JSON.parse(storedOrgRating).map(org => org.prize), 0);
            const maxComm = Math.max(...JSON.parse(storedOrgRating).map(org => org.comm), 0);
            setFirstValues({ tour: maxTour, prize: maxPrize, comm: maxComm });
        }
        setLoading(false)
    }, []); 

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 9;

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        window.scrollTo(0, 0)
    };

    const offset = currentPage * itemsPerPage;
    const currentItems = orgRating.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(orgRating.length / itemsPerPage);
    
    return <>
        {
            !isLoading ? <>
                <Header></Header>
                    <div className="services__page section-padding">
                        <div className="container">
                            <div className="row mb-30">
                                <div className="col-xl-6 col-lg-8">
                                    <div style={{marginBottom: '20px'}} className="services__page-title lg-t-center">
                                        <span className="subtitle">rating</span>
                                        <h2>Org rating</h2>
                                    </div>
                                    <ReactPaginate
                                        previousLabel={'<'}
                                        nextLabel={'>'}
                                        breakLabel={'..'}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={2}
                                        onPageChange={handlePageClick}
                                        containerClassName={'pagination-tme'}
                                        activeClassName={'active'}
                                        disabledClassName={'disabled'}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                {currentItems.sort((x, y) => (+y.prize + +y.tour + +y.comm) - (+x.prize + +x.tour + +x.comm)).map((item, id)=>(
                                    <>
                                        <div className="col-xl-12" key={id}>
                                            <div className="services__page-item media-rating-container">
                                                <div className="services__page-item-left">
                                                    <p style={{marginRight: '20px'}}>{id + 1}</p>
                                                    <div className="services__page-item-left-icon">
                                                        <img src={item.imageLink == '' ? '/images/cup.svg' : item.imageLink == 'none' ? '/images/cup.svg' : item.imageLink} alt="" />
                                                    <div className="services__area-item-icon-one">
                                                        <img src={item.teamLogo == '' ? '/images/cup.svg' : item.teamLogo == 'none' ? '/images/cup.svg' : item.teamLogo} alt="" />
                                                    </div>
                                                    </div>
                                                    <div className="services__page-item-left-content">
                                                        <h4><p>{item.name}</p></h4>
                                                    </div>
                                                </div>
                                                <div className='pr-card-box'>
                                                    <div className="pr-carg-rating-container">
                                                        <p>Tournaments - {item.tour}</p>
                                                        <span className="pr-card-rating-stick">
                                                            <div style={{ backgroundColor: (item.tour / firstValues.tour) * 100 < 25 ? "red" : (item.tour / firstValues.tour) * 100 < 75 ? '#ffc800' : (item.tour / firstValues.tour) * 100 < 100 ? 'rgb(3 253 69)' : 'rgb(3 253 69)', height: '100%', width: `${(item.tour / firstValues.tour) * 100}%` }}></div>
                                                        </span>
                                                    </div>
                                                    <div className="pr-carg-rating-container">
                                                        <p>Prizepool - {(item.prize)} $</p>
                                                        <span className="pr-card-rating-stick">
                                                            <div style={{ backgroundColor: (item.prize / firstValues.prize) * 100 < 25 ? "red" : (item.prize / firstValues.prize) * 100 < 75 ? '#ffc800' : (item.prize / firstValues.prize) * 100 < 100 ? 'rgb(3 253 69)' : 'rgb(3 253 69)', height: '100%', width: `${(item.prize / firstValues.prize) * 100}%` }}></div>
                                                        </span>
                                                    </div>
                                                    <div className="pr-carg-rating-container">
                                                        <p>Community - {item.comm}</p>
                                                        <span className="pr-card-rating-stick">
                                                            <div style={{ backgroundColor: (item.comm / firstValues.comm) * 100 < 25 ? "red" : (item.comm / firstValues.comm) * 100 < 75 ? '#ffc800' : (item.comm / firstValues.comm) * 100 < 100 ? 'rgb(3 253 69)' : 'rgb(3 253 69)', height: '100%', width: `${(item.comm / firstValues.comm) * 100}%` }}></div>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="services__page-item-right">
                                                    <a href="">Link</a>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ))}
                            </div>
                        </div>
                    </div>
                <FooterOne></FooterOne>        
            </> : <Preloader />
        }
    </>;
};

export default OrgRatingPage;